import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
const RESULTS_PATHNAME = '/results';
const ALLOWED_SEARCH_PARAM_KEYS = ['search', 'cat', 'tools'];
export const getResultsPagePath = (currentSearch, updatedSearchParams) => {
  const searchParams = new URLSearchParams(currentSearch);
  if (updatedSearchParams) {
    // Remove any allowed search parameters that are not being explicitly updated
    // This ensures only the parameters in updatedSearchParams are preserved
    for (const key of ALLOWED_SEARCH_PARAM_KEYS) {
      if (key in updatedSearchParams) {
        continue;
      }
      searchParams.delete(key);
    }
    for (const [key, value] of Object.entries(updatedSearchParams)) {
      searchParams.set(key, value);
    }
  }
  const searchParamsString = searchParams.toString();
  return `${RESULTS_PATHNAME}${searchParamsString ? `?${searchParamsString}` : ''}`;
};
export const isOnResultsPage = pathname => {
  return pathname === RESULTS_PATHNAME;
};
export const useNavigateToResultsPage = () => {
  const history = useHistory();
  const location = useLocation();
  return useCallback(searchParams => {
    if (isOnResultsPage(location.pathname)) {
      history.replace(getResultsPagePath(location.search, searchParams));
    } else {
      history.push(getResultsPagePath(undefined, searchParams));
    }
  }, [history, location]);
};